import cx from '../../../../utils/cx';

import { FIRST_STEP_NAME, SHORT_QUESTION_NAMES, THEME } from '../../../../config/quiz';

import backIcon from '../../../../images/quiz/back_icon.svg';
import backIconWhite from '../../../../images/quiz/back_icon_white.svg';

import styles from './ShortHeader.module.scss';

const ShortHeader = ({ current }) => {
  const currentIndex = SHORT_QUESTION_NAMES.indexOf(current);
  const dotIndex = currentIndex === -1 ? SHORT_QUESTION_NAMES.length : currentIndex;

  return (
    <div className={styles.header}>
      {current === FIRST_STEP_NAME ? (
        <span className={styles.spacer} />
      ) : (
        <button
          type="button"
          className={styles.backButton}
          onClick={() => window.history.back()}
          aria-label="Back"
        >
          <img src={THEME === 'christian' ? backIconWhite : backIcon} alt="" />
        </button>
      )}
      <div className={styles.dots}>
        {SHORT_QUESTION_NAMES.map((name, index) => (
          <span
            key={name}
            className={cx(styles.dot, {
              [styles.dotPast]: index < dotIndex,
              [styles.dotActive]: index === dotIndex,
            })}
          />
        ))}
      </div>
      <span className={styles.spacer} />
    </div>
  );
};

export default ShortHeader;
